import { supabase } from "../../supabaseClient";

export const EMPTY_RECAP_SHEET = {
  recapStoragePath: null,
  recapMimeType: null,
  recapFileName: null,
  recapBoundingBox: null,
};

const missingRecapColumn = (error) =>
  error?.code === "42703" ||
  /recapStoragePath|recapMimeType|recapFileName|recapBoundingBox/i.test(
    error?.message || ""
  );

export const clearTeamRecapSheet = async (teamId) => {
  let { error } = await supabase
    .from("teams")
    .update(EMPTY_RECAP_SHEET)
    .eq("id", teamId)
    .eq("isDeleted", false);
  if (error && /recapBoundingBox/i.test(error.message || "")) {
    const retry = await supabase
      .from("teams")
      .update({
        recapStoragePath: null,
        recapMimeType: null,
        recapFileName: null,
      })
      .eq("id", teamId)
      .eq("isDeleted", false);
    error = retry.error;
  }
  if (error) {
    if (missingRecapColumn(error)) {
      throw new Error(
        "This recap cannot be removed until the database is updated."
      );
    }
    throw error;
  }
};

export const attachRecapSheetFields = async (payload) => {
  if (!payload) return payload;
  const teams = payload.teams || [];
  const needsTeam = teams.some(
    (team) =>
      team.recapStoragePath === undefined ||
      team.recapBoundingBox === undefined
  );
  if (!needsTeam || !teams.length) return payload;

  const ids = teams.map((team) => team.id);
  let { data, error } = await supabase
    .from("teams")
    .select("id, recapStoragePath, recapMimeType, recapFileName, recapBoundingBox")
    .in("id", ids);
  if (error && /recapBoundingBox/i.test(error.message || "")) {
    const retry = await supabase
      .from("teams")
      .select("id, recapStoragePath, recapMimeType, recapFileName")
      .in("id", ids);
    data = retry.data;
    error = retry.error;
  }
  if (error) {
    if (missingRecapColumn(error)) return payload;
    throw error;
  }

  const teamById = Object.fromEntries(
    (data || []).map((row) => [row.id, row])
  );
  return {
    ...payload,
    teams: teams.map((team) => ({
      ...team,
      recapStoragePath:
        teamById[team.id]?.recapStoragePath ?? team.recapStoragePath ?? null,
      recapMimeType:
        teamById[team.id]?.recapMimeType ?? team.recapMimeType ?? null,
      recapFileName:
        teamById[team.id]?.recapFileName ?? team.recapFileName ?? null,
      recapBoundingBox:
        teamById[team.id]?.recapBoundingBox ?? team.recapBoundingBox ?? null,
    })),
  };
};
